import axios from "axios";

import { LEGALE_API_BASE_URL } from "../../utils/constants";

export const fetchSmartDocumentDetailRequest = (token, templateId) => {
  return new Promise((resolve, reject) => {
    axios
      .get(`${LEGALE_API_BASE_URL}/document/template/${templateId}`, {
        headers: { Authorization: `Bearer ${token}` },
      })
      .then((res) => resolve(res))
      .catch((e) => reject(e));
  });
};
